import * as React from 'react';
import { ViewProp } from '..';
import { PageIntro } from '../pageintro';
import * as mrCap from '../../mrCapTypes';
import * as api from '../../api/booking';
import format from 'date-fns/format';
import getDay from 'date-fns/getDay';
import addDays from 'date-fns/addDays';
import sv from 'date-fns/locale/sv';
import * as gtm from '../../gtm';

interface Props extends ViewProp {
}

interface State {
  orderInfo?: mrCap.OrderInfo;
}

export class Summary extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.initGoogleAds();
    this.initGtagEvent();
    this.initFacebookPixel();
    this.initAdnxs();
    this.getOrder();

    const win = window as any;
    win.dataLayer.push({
      event: 'bookingDone'
    });
  }

  async getOrder() {
    try {
      const order = await api.orderInfo(this.props.bookingId);
      this.setState({ orderInfo: order });
      this.trackPurchase(order);
    } catch (err) {
      // console.log(err);
    }
  };

  trackPurchase(order: mrCap.OrderInfo) {
    const campaignCode = this.props.campaign?.code;
    const products = this.props.selectedProducts.map(product => gtm.convertProduct(product, campaignCode));

    gtm.purchase({
      id: order.id + '',
      affiliation: 'Online booking',
      revenue: order.endPrice,
      coupon: campaignCode ?? '',
      tax: order.endVatPrice,
      shipping: order.shipping,
      option: order.paymentProvider
    }, products);
  }

  initGoogleAds() {
    // Event snippet for Köp NY conversion page
    const script = document.createElement('script');
    script.text =
    "gtag('event', 'conversion', { 'send_to': 'AW-1014104274/eQwCCL3jxvYBENKByOMD', 'transaction_id': '' });";
    document.head.appendChild(script);
  }

  initGtagEvent() {
    const script = document.createElement('script');
    script.text =
    "gtag('event', 'booked', { 'event_category': 'booking', 'send_to': 'UA-141832297-45', });";
    document.head.appendChild(script);
  }

  initFacebookPixel() {
    const script = document.createElement('script');
    script.text =
    // eslint-disable-next-line max-len
    "!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init', '474461227134502');fbq('track', 'PageView');";
    document.head.appendChild(script);

    const noscript = document.createElement('noscript');
    // eslint-disable-next-line max-len
    noscript.innerHTML = '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=474461227134502&ev=PageView&noscript=1"/>';
    document.head.appendChild(noscript);
  }

  initAdnxs() {
    const script = document.createElement('script');
    script.src = 'https://secure.adnxs.com/px?id=1479645&seg=26442349&t=1';
    document.head.appendChild(script);
  }

  render() {
    const { campaign } = this.props;
    const shop = this.props.selectedShop!;
    const onlyProducts = this.props.selectedProducts.every(item => item.type === mrCap.ArticleType.product);
    const selectedDate = this.props.selectedDate!;

    // Checks if theres any products that has to be picked up the day after
    const dayAfterProducts = this.props.selectedProducts.some(item => item.pickUpDayAfter === true);

    // Checks if the date is a friday
    const pickUpFriday = selectedDate && getDay(selectedDate) === 5;

    // If the date is a friday, add three full days, otherwise add one
    const pickUpDay = pickUpFriday ? addDays(selectedDate, 3) : addDays(selectedDate, 1);

    const rental = !!this.props.selectedMabi;
    const rentalVehicle = rental
      ? this.props.mabi?.vehicles.find(vehicle => vehicle.artNr === this.props.selectedMabi)
      : null;

    return (
      <div className='outer-page'>
        <div className='page'>

          <div className='page-top-content'>
            <PageIntro
              header={this.props.texts.stepFourHeader}
              preamble={this.props.texts.stepFourParagraph} />
          </div>
          <div className='summary-list-float'>
            {!onlyProducts && <>
              <div>
                <strong>Anläggning</strong>
                <span>{shop.name}</span>
              </div>
              <div>
                <strong>Kontaktuppgifter anläggning</strong>
                <span>{this.props.selectedShop?.phone}</span>
                <span>{this.props.selectedShop?.email}</span>
              </div>
              <div>
                <strong>Datum</strong>
                <span>{format(this.props.selectedDate!, 'PPPP', {locale: sv})}</span>
              </div>
              {this.props.regNr && <>
                <div>
                  <strong>Registreringsnummer</strong>
                  <span>{this.props.regNr}</span>
                </div>
                {this.props.carDetails && <>
                  <div>
                    <strong>Fordon</strong>
                    <span>{this.props.carDetails.brand + ', ' + this.props.carDetails.model}</span>
                  </div>
                </>}
              </>}
              <div>
                <strong>Inlämningstid</strong>
                <span>{format(this.props.selectedDate!, 'dd MMMM', {locale: sv})}, 08 - 09</span>
              </div>
              {dayAfterProducts && pickUpDay && <>
                <div>
                  <strong>Hämtningstid</strong>
                  <span>Du kan hämta din bil tidigast {format(pickUpDay, 'dd MMMM', {locale: sv})} från 08.00</span>
                </div>
              </>}
              {this.state.orderInfo && <>
                <div>
                  <strong>Bokningsnummer</strong>
                  <span>{this.state.orderInfo.id}</span>
                </div>
              </>}
            </>}
            <div>
              <strong>{this.props.selectedProducts.length > 1 ? 'Produkter' : 'Produkt'}</strong>
              {this.props.selectedProducts.map(name => <span>{name.title}</span>)}
            </div>
            {this.state.orderInfo && <>
              {this.state.orderInfo.firstName && <>
                <div>
                  <strong>Ditt namn</strong>
                  <span>{this.state.orderInfo.firstName + ' ' + this.state.orderInfo.lastName}</span>
                </div>
              </>}
              {(this.state.orderInfo.phone || this.state.orderInfo.email) && <>
                <div>
                  <strong>Dina kontaktuppgifter</strong>
                  <span>{this.state.orderInfo.phone}</span>
                  <span>{this.state.orderInfo.email}</span>
                </div>
              </>}
              <div>
                <strong>Betalningsmetod</strong>
                <span>{this.state.orderInfo.paymentReference}</span>

                {/* paymentReference är "Betalning på plats" från backend */}
                <span>{this.state.orderInfo.paymentProvider === 'OnLocation'
                  ? null : this.state.orderInfo.paymentProvider }</span>
              </div>
            </>}

            {campaign && <>
              <div>
                <strong>Kampanj</strong>
                <span>{campaign.name} {campaign.discount > 0
                  ? `(${campaign.discount} %)`
                  : null}</span>
              </div>
            </>}

            {rental && rentalVehicle && <>
              <div>
                <strong>Hyrbil</strong>
                <span>{rentalVehicle.name}</span>
              </div>
            </>}
          </div>
        </div>
      </div>
    );
  }
}